import { State, Action, StateContext, Selector } from '@ngxs/store';
import { IBeneficiaryDetails } from '../../../core/modules/admin-modules/beneficiary/models/beneficiary.model';
import { PatchPatientDetails } from './patient.action';

interface PatientStateModel {
  patient: IBeneficiaryDetails | null;
}

@State<PatientStateModel>({
  name: 'patient',
  defaults: {
    patient: null
  }
})
export class PatientState {

  @Selector()
  static Patient(state: PatientStateModel) {
    return state?.patient;
  }

  @Action(PatchPatientDetails)
  PatchPatientDetails(ctx: StateContext<PatientStateModel>, { payload }: PatchPatientDetails) {
    ctx.patchState({
      patient: payload
    });
  }
}